// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n[data-v-3a938559] .el-menu-item {\n  color: rgb(51, 51, 51) !important;\n}\n[data-v-3a938559] .el-menu-item.is-active {\n  background-color: #fff !important;\n  color: rgb(51, 51, 51) !important;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
